@if (definition && definition.visible | booleanRule: value:true) {
  @if (!loading) {
    <ng-container
      softDynamicValueField
      [definition]="definition"
      [value]="value"
    ></ng-container>
  } @else {
    <soft-dynamic-skeleton [definition]="definition"> </soft-dynamic-skeleton>
  }
}
